import { cellComponents } from "@portal/BaseComponents/Table/Components/cellComponents";
import { Table } from "@sinecycle/growcomponents";
import styled from "styled-components";
import { LineItemTableProps } from "./type";
import { useColumns } from "./useColumns";
const LineItemWrapper = styled.div``;
function LineItemTable(props: LineItemTableProps) {
  const { loading, lineItem } = props;
  const { colConfigs } = useColumns();

  return (
    <LineItemWrapper>
      <Table
        loading={Boolean(loading)}
        gridProps={{
          rowData: lineItem,
          columnDefs: colConfigs,
          domLayout: "autoHeight",
          components: cellComponents,
          enableCellTextSelection: true,
          defaultColDef: {
            autoHeight: true,
            flex: 1,
            wrapHeaderText: true,
          },
        }}
        tablePaginationProps={{
          hide: true,
        }}
        handlePageChange={() => {}}
        sortMode={{
          type: "local",
          defaultSort: [],
        }}
      />
    </LineItemWrapper>
  );
}

export { LineItemTable };
